//#region IMPORT
import React, { useEffect, useState } from 'react';
import M_TBG_BASIC_09 from './M_TBG_BASIC_09';
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import { useBackStack } from '../../../Hooks/back/useBackStack';
//#endregion

function M_TBG_BASIC_09F(props) {
  //#region 변수
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const { navigate } = useAppNavigate(); // 네비게이션을 위한 훅
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    type: 'info',
  });

  //#endregion

  // 스택형 뒤로가기로 변경: TBM 종료 전 이탈 시 확인 시트 표시
  useBackStack({
    type: 'sheet',
    enabled: !bottomSheetState.bottom,
    onBack: () =>
      dispatch(BottomSheetActions.OpenBottomSheet({ type: 'backClickTbmEnd' })),
  });

  useEffect(() => {
    Init();
    return () => {
      dispatch(BottomSheetActions.CloseBottomSheet());
    };
  }, [dispatch]);

  const Init = async () => {
    setLoading(true);
    try {
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  //#region 조회
  //#endregion
  //#region 저장
  //TBM 회의 기초정보 저장
  const SaveLogic1 = async () => {
    setLoading(true);
    let saveData = [];
    try {
      saveData.push({
        procedureName: 'SP_M20908_U1',
        _tbmCd: Commons.EncryptAES(props.tbmCdRef.current) || '', // TBM코드
        _userid: userInfo.userid, // 담당자ID
      });

      if (saveData.length > 0) {
        await Commons.Axios(
          'post1',
          Global.base.useUrl + Global.urls.Execute.execute,
          saveData
        ).then(async (result) => {
          let data = result?.data[0];
          if (data.type === 'Error') {
            throw new Error(data.message);
          } else {
            setSnackbar({
              open: true,
              type: 'success',
              message:
                lanInfo.length === 0
                  ? ''
                  : lanInfo.find(
                      (f) =>
                        f.lanType !== 'MENU' && f.lanId === 'ItHasBeenSaved'
                    ).lanNm, //저장되었습니다.
            });
            // 보호구 자가 체크
            navigate('/M21001');
            dispatch(CommonActions.setActiveStep(0));
          }
        });
      }
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  //#endregion
  //#region 나머지 함수
  const Complete = () => {
    dispatch(CommonActions.setActiveStep(0));
    navigate('/M_PPE', { state: { tbmCd: props.tbmCdRef.current } });
  };
  //#endregion

  return (
    <M_TBG_BASIC_09
      // 함수
      SaveLogic1={SaveLogic1}
      setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
      TbmEnd={props.TbmEnd}
      Complete={Complete}
    />
  );
}

export default M_TBG_BASIC_09F;
